import { PPLX_SESSION_ID_COOKIE, PPLX_VISITOR_ID_COOKIE, } from '#pplx/frontend/cookies/constants.js';
import { getCookie } from '#pplx/frontend/cookies/provider.js';
export function getSessionIdCookie() {
    return getCookie(PPLX_SESSION_ID_COOKIE);
}
export function getVisitorIdCookie() {
    return getCookie(PPLX_VISITOR_ID_COOKIE);
}
//# sourceMappingURL=sessionCookieManager.js.map